import { apiService } from 'services';
import { IPhoneNumber } from 'services/PhoneNumber';

export const getPhoneNumbers = (callback: any, errorCallback: any) => {
    apiService.get<IPhoneNumber[]>('/phone/numbers', callback, errorCallback);
};

export const sendSMS = (body: any, callback: any, errorCallback: any) => {
    apiService.post<any>('/phone/send', body, callback, errorCallback);
};

export const sendCall = (body: any, callback: any, errorCallback: any) => {
    apiService.post<any>('/phone/call', body, callback, errorCallback);
};
